// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-container-label-point {
  width: 100%;
  height: 100%;
  padding: 5px;
  background-color: var(--background-color-4);
}

.container-treelist-label-point {
  border-radius: 4px;
  border: 1px solid var(--border-color-1);
  padding: 0;
  overflow: auto;
  position: relative;
  margin: 0;
  height: calc(100% - 35px);
}

.color-indicator {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 10px;
  display: inline-block;
}

.btn-group-point {
  width: 100%;
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
}

.btn-group-point .disable {
  cursor: no-drop;
  opacity: 0.5;
}

.btn-tool-labelPoint {
  background: var(--background-color-3);
  border-color: #adb1b8;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-sizing: border-box;
  border-radius: 4px;
  float: left;
  height: 25px;
  text-align: center;
  width: 25px;
  padding: 2px 2px;
  cursor: pointer;
}

.btn-tool-labelPoint:hover {
  border-color: var(--primary-color-1);
}

.btn-tool-labelPoint:hover svg {
  stroke: var(--primary-color-1);
  fill: var(--primary-color-1);
}

.hidden {
  display: none;
}

.btn-tool-labelPoint svg {
  width: 100%;
  height: 100%;
  stroke: var(--color-text-3);
  fill: var(--color-text-3);
}

.btn-group-point button {
  margin-left: 3px;
}

.btn-group-point button:nth-child(1) {
  margin-left: 0px;
}

.btn-tool-labelPoint.active {
  border-color: var(--primary-color-1);

}

.btn-tool-labelPoint.active svg {
  stroke: var(--primary-color-1);
  fill: var(--primary-color-1);
}

.folder-icon-indicator {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/labelPoint.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;;AAEtC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".wrapper-container-label-point {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 5px;\r\n  background-color: var(--background-color-4);\r\n}\r\n\r\n.container-treelist-label-point {\r\n  border-radius: 4px;\r\n  border: 1px solid var(--border-color-1);\r\n  padding: 0;\r\n  overflow: auto;\r\n  position: relative;\r\n  margin: 0;\r\n  height: calc(100% - 35px);\r\n}\r\n\r\n.color-indicator {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  margin-right: 10px;\r\n  display: inline-block;\r\n}\r\n\r\n.btn-group-point {\r\n  width: 100%;\r\n  margin: 5px 0;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.btn-group-point .disable {\r\n  cursor: no-drop;\r\n  opacity: 0.5;\r\n}\r\n\r\n.btn-tool-labelPoint {\r\n  background: var(--background-color-3);\r\n  border-color: #adb1b8;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-radius: 3px;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  float: left;\r\n  height: 25px;\r\n  text-align: center;\r\n  width: 25px;\r\n  padding: 2px 2px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-tool-labelPoint:hover {\r\n  border-color: var(--primary-color-1);\r\n}\r\n\r\n.btn-tool-labelPoint:hover svg {\r\n  stroke: var(--primary-color-1);\r\n  fill: var(--primary-color-1);\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n.btn-tool-labelPoint svg {\r\n  width: 100%;\r\n  height: 100%;\r\n  stroke: var(--color-text-3);\r\n  fill: var(--color-text-3);\r\n}\r\n\r\n.btn-group-point button {\r\n  margin-left: 3px;\r\n}\r\n\r\n.btn-group-point button:nth-child(1) {\r\n  margin-left: 0px;\r\n}\r\n\r\n.btn-tool-labelPoint.active {\r\n  border-color: var(--primary-color-1);\r\n\r\n}\r\n\r\n.btn-tool-labelPoint.active svg {\r\n  stroke: var(--primary-color-1);\r\n  fill: var(--primary-color-1);\r\n}\r\n\r\n.folder-icon-indicator {\r\n  width: 18px;\r\n  height: 18px;\r\n  margin-right: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
